import * as actionTypes from '../constants/action-types';

const initialState = {
    isRequesting: false,
    personRoleList: [],
    operatorList: [],
    personList: [],
    stateList: [],
    personInfo: {},
    countryList: []
}

export default (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_PERSON_LIST_REQUEST: {
            state = { ...state, isRequesting: true, personList: initialState.personList };
            break;
        }
        case actionTypes.GET_OPERATOR_LIST_REQUEST: {
            state = { ...state, isRequesting: true, operatorList: initialState.operatorList };
            break;
        }
        case actionTypes.GET_PERSON_CONFIG: {
            const p = action.payload;
            state = {
                ...state,
                personRoleList: p ? p.person_role : initialState.personRoleList
            };
            break;
        }
        case actionTypes.GET_OPERATOR_LIST:
            state = { ...state, isRequesting: false, operatorList: action.payload };
            break;
        case actionTypes.GET_PERSON_LIST:
            state = { ...state, isRequesting: false, personList: action.payload };
            break;
        case actionTypes.GET_PERSON_INFO:
            state = { ...state, personInfo: action.payload };
            break;
        case actionTypes.GET_COUNTRY_LIST:
            state = { ...state, countryList: action.payload };
            break;
        case actionTypes.GET_STATE_LIST:
            state = { ...state, stateList: action.payload };
            break;
        case actionTypes.CLEAR_OPERATOR_LIST:
            state = { ...state, operatorList: initialState.operatorList };
            break;
        default:
            break;
    }
    return state;
}
